import { CREATE_DOMAIN, DELETE_DOMAIN, EDIT_DOMAIN, GET_DOMAINS } from './domain.types';

/** Domains */

export const getDomains = (params, load) => {
    return {
        type: GET_DOMAINS,
        payload: { params, load },
    };
};

export const createDomain = (body, params) => {
    return {
        type: CREATE_DOMAIN,
        payload: { body, params },
    };
};

export const editDomain = (id, body) => {
    return {
        type: EDIT_DOMAIN,
        payload: { id, body },
    };
};

export const deleteDomain = (id, module, requestParams) => {
    return {
        type: DELETE_DOMAIN,
        payload: { id, module, requestParams },
    };
};

/** End */
